/**
 * Asynchronously loads the component for Device Details Page
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
